import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { SharedModule } from '@ddt-web/common';
import { DataServiceModule } from '@ddt-web/data-service';
import { DomModule } from '@ddt-web/dom';
import { GenericPipesModule } from '@ddt-web/generic-utils';

import { TableCellComponent } from './table-cell.component';

@NgModule({
	declarations: [TableCellComponent],
	imports: [
		CommonModule,
		CwpNgFrameworkModule,
		GenericPipesModule,
		SharedModule,
		DataServiceModule,
		DomModule
	],
	exports: [TableCellComponent]
})
export class TableCellModule { }
